window.Popper = require('popper.js').default;
try {
    // window.$ = window.jQuery = require('jquery');
} catch (e) {
    // console.log(e);
}

require('./main');
// require('./the-events-calendar');
require('./listings');
require('./search-bar');
require('./nav-main');
require('./normalize-bs-slider-height');
require('./toggle-class');
require('./dropdown-box');
require('./tab-transform');
require('./listings-filter-search');
require('./filter-breadcrumbs');
require('./date-picker');
